export class CassetteEvents {
    static CassetteRemovedEventRaised = 'CassetteRemovedEventRaised';
    static CassetteInsertedEventRaised = 'CassetteInsertedEventRaised';
}
